export default "__VITE_ASSET__B7aOvEob__"